import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Datenschutz() {
    return (
        <div className="relative min-h-screen overflow-hidden bg-black" data-testid="datenschutz-page">
            <div className="grain-overlay" />
            <div className="pointer-events-none absolute -top-40 -right-40 h-[400px] w-[400px] rounded-full bg-[#FF5A00]/10 blur-[120px]" />

            <nav className="relative z-10 px-6 py-6 sm:px-10">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-white/60 transition hover:text-[#FF5A00]"
                    data-testid="back-to-home"
                >
                    <ArrowLeft size={14} />
                    zurück
                </Link>
            </nav>

            <div className="relative z-10 mx-auto max-w-3xl px-6 pb-24 pt-4 sm:px-10">
                <h1 className="font-display text-4xl font-black tracking-tight text-white sm:text-5xl">
                    Datenschutz&shy;erklärung
                </h1>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                    Privacy Policy
                </p>

                <div className="mt-12 space-y-10 text-sm leading-relaxed text-white/70 sm:text-base">
                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            1. Verantwortliche Stelle
                        </h2>
                        <p>
                            Verantwortlich für die Datenverarbeitung auf dieser Webseite ist
                            Kylie West. Kontakt:{" "}
                            <a
                                href="mailto:business@kyliewest.us"
                                className="text-[#FF5A00] underline-offset-4 hover:underline"
                            >
                                business@kyliewest.us
                            </a>
                            . Vollständige Anschrift siehe{" "}
                            <Link
                                to="/impressum"
                                className="text-[#FF5A00] underline-offset-4 hover:underline"
                            >
                                Impressum
                            </Link>
                            .
                        </p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            2. Welche Daten wir erheben
                        </h2>
                        <p className="mb-3">
                            Wenn du dich für unseren Newsletter / das gratis Foto einträgst,
                            verarbeiten wir folgende Daten:
                        </p>
                        <ul className="list-disc space-y-1 pl-6 text-white/60">
                            <li>Email-Adresse (Pflicht)</li>
                            <li>Name (freiwillig)</li>
                            <li>IP-Adresse (zur Spam-Abwehr & Geo-Auswertung auf Länderebene)</li>
                            <li>Land / Stadt (abgeleitet aus der IP)</li>
                            <li>Zeitpunkt der Anmeldung</li>
                            <li>Klicks auf Links in unseren Emails (zur Erfolgsmessung)</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            3. Zweck & Rechtsgrundlage
                        </h2>
                        <p className="mb-3">
                            Die Verarbeitung erfolgt zum Versand von Marketing- und
                            Content-Emails (z.B. exklusive Fotos, News, Angebote) sowie zur
                            statistischen Auswertung der Email-Performance.
                        </p>
                        <p>
                            Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), die
                            du durch das Absenden des Formulars erteilst. Du kannst diese
                            Einwilligung jederzeit widerrufen — z.B. über den
                            Abmelde-Link am Ende jeder Email oder per Mail an{" "}
                            <a
                                href="mailto:business@kyliewest.us"
                                className="text-[#FF5A00] underline-offset-4 hover:underline"
                            >
                                business@kyliewest.us
                            </a>
                            .
                        </p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            4. Empfänger / Auftragsverarbeiter
                        </h2>
                        <p className="mb-3">
                            Wir nutzen folgende externe Dienstleister:
                        </p>
                        <ul className="list-disc space-y-2 pl-6 text-white/60">
                            <li>
                                <strong className="text-white">Resend</strong> — Versand von
                                Transaktions- und Marketing-Emails (USA).
                            </li>
                            <li>
                                <strong className="text-white">ipapi.co</strong> — IP-basierte
                                Geolokalisierung auf Länder-/Stadtebene.
                            </li>
                            <li>
                                <strong className="text-white">PostHog</strong> — anonymisierte
                                Nutzungsstatistik. Session-Recording ist deaktiviert.
                            </li>
                            <li>
                                <strong className="text-white">MongoDB Atlas</strong> — sichere
                                Speicherung der Lead-Daten.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            5. Speicherdauer
                        </h2>
                        <p>
                            Wir speichern deine Daten so lange, wie du eingetragen bist. Nach
                            Abmeldung werden personenbezogene Daten innerhalb von 30 Tagen
                            gelöscht — sofern keine gesetzlichen Aufbewahrungspflichten
                            entgegenstehen.
                        </p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            6. Deine Rechte
                        </h2>
                        <p className="mb-3">Du hast jederzeit das Recht auf:</p>
                        <ul className="list-disc space-y-1 pl-6 text-white/60">
                            <li>Auskunft über deine gespeicherten Daten (Art. 15 DSGVO)</li>
                            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                            <li>Löschung deiner Daten (Art. 17 DSGVO)</li>
                            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                            <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                            <li>
                                Beschwerde bei einer Datenschutz-Aufsichtsbehörde
                            </li>
                        </ul>
                        <p className="mt-3">
                            Schreib uns einfach an{" "}
                            <a
                                href="mailto:business@kyliewest.us"
                                className="text-[#FF5A00] underline-offset-4 hover:underline"
                            >
                                business@kyliewest.us
                            </a>{" "}
                            — wir kümmern uns schnell und unkompliziert.
                        </p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            7. Cookies & Tracking
                        </h2>
                        <p>
                            Wir setzen technisch notwendige Cookies sowie ein anonymisiertes
                            Analyse-Tool (PostHog) ein. Es werden keine Sitzungen aufgezeichnet.
                            Du kannst Cookies in deinem Browser jederzeit löschen oder blockieren.
                        </p>
                    </section>

                    <section>
                        <h2 className="mb-3 font-display text-lg font-bold text-white">
                            8. Sicherheit
                        </h2>
                        <p>
                            Die Übertragung erfolgt verschlüsselt über HTTPS (TLS). Daten
                            werden auf Servern mit moderner Verschlüsselung gespeichert.
                        </p>
                    </section>
                </div>

                <p className="mt-16 font-mono text-[10px] uppercase tracking-[0.25em] text-white/30">
                    Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
                </p>
            </div>
        </div>
    );
}
